import type {
	FilterStatusOption,
	FiltersState,
	Props,
} from "../core/types/tsx/components/FiltersPedidos.types";

const DEFAULT_STATUS_OPTIONS: FilterStatusOption[] = [
	{ value: "Dialogando", label: "Dialogando" },
	{ value: "En Espera", label: "En Espera" },
	{ value: "En_Progreso", label: "En Progreso" },
	{ value: "Completado", label: "Completado" },
	{ value: "Pagado", label: "Pagado" },
	{ value: "Soporte", label: "Soporte" },
	{ value: "Garantia", label: "Garantía" },
	{ value: "Cancelado", label: "Cancelado" },
];

export function FiltersPedidos({
	filters,
	onChange,
	onClear,
	statusOptions,
	showLocationFilter = true,
}: Props) {
	const handle =
		(key: keyof FiltersState) =>
		(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
			onChange({ ...filters, [key]: e.target.value });
		};

	// Clases comunes para inputs y selects para garantizar la misma altura y estilo
	const commonInputClasses =
		"w-full border soft-border bg-white rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 h-[42px]";

	const resolvedStatusOptions = statusOptions ?? DEFAULT_STATUS_OPTIONS;

	return (
		<section className='bg-white rounded-2xl soft-border card-shadow p-6'>
			<h2 className='text-sm font-semibold text-gray-700 mb-1'>
				Filtros de Búsqueda
			</h2>
			<p className='text-xs text-gray-400 mb-4'>
				Filtra pedidos por nombre, código, estado o fecha
			</p>

			{/* Usamos items-end para alinear todo a la línea base de los inputs */}
			<div className='flex gap-4 items-end flex-wrap'>
				{/* BUSCADOR */}
				<div className='flex-1 min-w-65'>
					<label className='block text-xs text-gray-400 mb-2'>
						Buscar Pedido
					</label>
					<div className='relative'>
						<svg
							className='w-5 h-5 text-gray-400 absolute left-3 top-3'
							viewBox='0 0 24 24'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M21 21l-4.35-4.35'
								stroke='currentColor'
								strokeWidth='2'
								strokeLinecap='round'
								strokeLinejoin='round'
							/>
							<circle
								cx='11'
								cy='11'
								r='6'
								stroke='currentColor'
								strokeWidth='2'
							/>
						</svg>
						<input
							// Sobrescribimos el padding-left (pl-10) para el icono
							className={`${commonInputClasses} pl-10`}
							placeholder='Buscar por ID, nombre, empresa...'
							value={filters.term}
							onChange={handle("term")}
						/>
					</div>
				</div>

				{/* ESTADO (CORREGIDO) */}
				<div className='w-48 min-w-40'>
					<label className='block text-xs text-gray-400 mb-2'>Estado</label>
					<div className='relative'>
						<select
							className={`${commonInputClasses}`}
							value={filters.status}
							onChange={handle("status")}
						>
							<option value=''>Todos</option>
							{resolvedStatusOptions.map((option) => (
								<option key={option.value} value={option.value}>
									{option.label}
								</option>
							))}
						</select>
						{/* Flecha personalizada para reemplazar la nativa */}
					</div>
				</div>

				{/* FECHA */}
				<div className='w-48 min-w-40'>
					<label className='block text-xs text-gray-400 mb-2'>Fecha</label>
					<input
						type='date'
						className={commonInputClasses}
						value={filters.date}
						onChange={handle("date")}
					/>
				</div>

				{showLocationFilter ? (
					<div className='w-48 min-w-40'>
						<label className='block text-xs text-gray-400 mb-2'>
							Ubicación
						</label>
						<input
							className={commonInputClasses}
							placeholder='Dirección...'
							value={filters.ubicacion}
							onChange={handle("ubicacion")}
						/>
					</div>
				) : null}

				{/* BOTÓN MOVIDO AL CONTENEDOR FLEX */}
				<button
					className='inline-flex items-center gap-2 text-sm text-gray-500 hover:text-primary transition-colors cursor-pointer h-10.5 px-2'
					onClick={onClear}
				>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						className='h-4 w-4'
						fill='none'
						viewBox='0 0 24 24'
						stroke='currentColor'
					>
						<path
							strokeLinecap='round'
							strokeLinejoin='round'
							strokeWidth={2}
							d='M3 4h18M4 9h16M6 14h12M9 19h6'
						/>
					</svg>
					Limpiar Filtros
				</button>
			</div>
		</section>
	);
}

export default FiltersPedidos;
